// eslint-disable-next-line import/prefer-default-export
export const setTruncate = (text, length, clamp) => {
  // eslint-disable-next-line no-param-reassign
  clamp = clamp || '...'
  const node = document.createElement('div')
  node.innerHTML = text
  const content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}
